import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppStateService } from '../../../../services/app-state.service';
import { InitService } from '../../../../parsers/init.service';
import { Config, Path } from '../../../../enums';
import { USER_MGMT_CNST, USER_MGMT_DEFAULT_CONFIG_CNST } from '../../../../constants/proj.cnst';
import { UM_TABLE_CNST } from '../../../../constants/table.cnst';
import { DataService } from '../../../../services/data.service';
import { CommonService } from '../../../../services/common.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service'
import { EnvService } from '../../../../services/env.service';
import { catchError, forkJoin, Observable, of } from 'rxjs';
import { MatStepper } from '@angular/material/stepper';
import { isNullOrUndefined } from 'shared-library';

@Component({
  selector: 'lib-user-config',
  templateUrl: './user-config.component.html',
  styleUrls: ['./user-config.component.scss']
})
export class UserConfigComponent implements OnInit {

  // Step Configaration
  stepConfig: {
    info: number,
    role: number,
    scope: number
  } = {
    info: 1,
    role: 0,
    scope: 0
  };
  currentTab: string = 'info';
  currentTabIndex : number = 0;
  scopeValueList: any[] = [];

  //Constants
  constants = USER_MGMT_DEFAULT_CONFIG_CNST.ADD_USER_CONST;
  superAdmin: any = USER_MGMT_CNST.SUPER_ADMIN;
  productStandardAppsIds = USER_MGMT_CNST.PRODUCT_STANDARD_APPLICATION_IDS;

  // Create/Update User Details
  userDetails: any;
  emailPattern: any = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  isEmailValid : boolean = true;
  userId: any = null;
  userConfig: any = null  as any;
  customerList: any;
  allUserList: any;
  filteredUsersList: any;
  userForm: FormGroup = new FormGroup({});
  // Mobile Number Control
  primaryMobileForm = new FormGroup({
		primaryMobileNo: new FormControl(undefined, [Validators.required]),
	});
  isPrimaryMobileNoValid : boolean = true;
  currentCountryCode : string = "in";

  // Logged In User Details
  userPermission:any;
  userMetaInfo: any;
  isCustomer: any;
  operation: any = null;
  
  userDbSnapshot: any = {};

  //Edit User:: Role 
  roleForm: FormGroup = new FormGroup({});
  roles : any[] = [];
  filteredRoles: any[] = [];
  selectedApplications: any = {};
  filterOptions: any = {}; // key: filterName, value: options.

  appIdMap: {[key: string]: any} = {}; // Application: ScopeEndPoint

  applications: any[] = [];

  addedRoles : any = 1;
  selectedProfiles : any = [];
  selectedCustomers : any = [];
  selected= [];

  currentRoleName : any = null;
  currentApplicationName : any = null;
  roleRemoved : boolean = false;
  scopeChildAvailable: boolean = false;

  customerName: any = null;
  customerId : any = null;
  userName : any = null;
  mobileNumber : any = null;
  updateInProcess: boolean = false;
  roleDetails: any[] = [];
  objectKeys = Object.keys;
  @ViewChild("stepper", { static: false }) stepper!: MatStepper;
  title:any;
  userConfigOperations: any = USER_MGMT_CNST.USER_MODULE_OPERATIONS;
  customerExtraFields:any = [];
  hasExtraFields:boolean = false;
  extraFieldsJson!:any;
  loading:boolean = false;

  // extended scope implementation
  userPermissionresourseList:any = {};
  userApplications:any = [];
  isScopeValid:boolean = false;
  isScopeValidObject:any = {}

  constructor(
    private appState: AppStateService,
    private initSrv: InitService,
    private activatedRoute: ActivatedRoute,
    private httpSrv: HttpService,
    private dataSrv: DataService,
    private utilSrv: UtilsService,
    private envService: EnvService,
    private router: Router,
    private _formBuilder:FormBuilder,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.operation = params['operation'];
      this.userId = params['userId'];
      this.title = params?.title;
      const tabs = Object.keys(this.stepConfig);
      if(params['config'] && tabs.includes(params['config'])){
        tabs.forEach((tab: string,index : number) => {
          if(tab == params['config']) {
            this.currentTabIndex = index;
            this.stepConfig[tab as keyof typeof this.stepConfig] = 1;
          }else {
            this.stepConfig[tab as keyof typeof this.stepConfig] = 0;
          }
        })
      }
      let { USER_MODULE_OPERATIONS } = USER_MGMT_CNST;
      this.userMetaInfo = this.appState.getUserMetaInfo();
      this.isCustomer = this.userMetaInfo && (this.userMetaInfo['customerId']|| this.userMetaInfo['customerName']) ? true : false;
      this.customerId = this.userMetaInfo['customerId'];
      this.roleForm = new FormGroup({
        newRole: new FormControl('', []),
        scope: new FormArray([])
      });
      if(this.operation === USER_MODULE_OPERATIONS.ADD_USER) {
        this.addUserConfigaration();
        this.userPermission = this.appState.getUserPermissions();
        if (!this.isCustomer) {
          this.userForm = new FormGroup({
            firstName: new FormControl('', [Validators.required]),
            lastName: new FormControl('', []),
            username: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
            customers: new FormControl('', []),
            reportingToId: new FormControl('', [])
          });
        } else {
          this.userForm = new FormGroup({
            firstName: new FormControl('', [Validators.required]),
            lastName: new FormControl('', []),
            username: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
            reportingToId: new FormControl('', [])
          });
        }
        if(this.customerId){
          this.fetchAdditionalFields(false,this.customerId);
        }
      }else if(this.operation === USER_MODULE_OPERATIONS.UPDATE_USER || this.operation === USER_MODULE_OPERATIONS.VIEW_USER){
        this.editUserConfigaration();
        this.userForm = new FormGroup({
          firstName: new FormControl('', [Validators.required]),
          lastName: new FormControl('', []),
          status: new FormControl('Active', [Validators.required]),
          email: new FormControl('', [Validators.required, Validators.pattern(this.emailPattern)]),
          customer : new FormControl('', []),
          username : new FormControl('', []),
          reportingToId: new FormControl('', [])
        });
        
        this.currentRoleName = params['roleName'];
        this.currentApplicationName = params['applicationName'];
        this.loadData();
      }
    });
  }

  async fetchAdditionalFields(isAdd:boolean,customerId:string){
    this.loading = true;
   await this.httpSrv.makeGetApiCall('FETCH_ADDITIONAL_USERFORM_FIELDS',this.envService.baseUrl,{
      replaceParams: {
        REPLACE_CUSTOMER_ID: customerId,
      },
    }).subscribe({
      next:(response:any) => {
        this.additionalFieldsFormGroupGenerator(response.response,customerId);
        if(!isAdd){
          this.patchExtraFieldValues(this.userDetails);
        }
        this.loading = false;
      },
      error:(err:any) => {
        this.loading = false;
      }
    })
  }

  additionalFieldsFormGroupGenerator(responce:any,customerId:string){
    this.extraFieldsJson = responce.find((data:any) => data.customerId === customerId);
    if(this.extraFieldsJson){
      this.initializeExtraFields(this.extraFieldsJson.customerExtraFields);
    }else{
      this.customerExtraFields = [];
      this.hasExtraFields = false;
      if (this.userForm.contains('extraFields')) {
        this.userForm.removeControl('extraFields');
      }
    }
  }

  patchExtraFieldValues(userDetails:any){
    if(userDetails?.userDetailsJson){
      this.userForm.get('extraFields')?.patchValue(userDetails.userDetailsJson?.data);
    }
  }


   // Call this method when you receive the extra fields list
   initializeExtraFields(extraFields: string[]) {
    this.customerExtraFields = extraFields.map((field: string) => ({
      control: field,
      label: field.replace(/_/g, ' ')
    }));
    if (extraFields && extraFields.length > 0) {
      // Add the extraFields FormGroup only if we have fields
      this.userForm.addControl('extraFields', this.createExtraFieldsGroup());
      this.hasExtraFields = true;
    } else {
      // Remove the extraFields FormGroup if it exists
      if (this.userForm.contains('extraFields')) {
        this.userForm.removeControl('extraFields');
      }
      this.hasExtraFields = false;
    }
  }

  private createExtraFieldsGroup(): FormGroup {
    const group:any = {};
    this.customerExtraFields.forEach((fieldName:{control:string,label:string}) => {
      group[fieldName.control] = ['',Validators.required]; 
    });
    return this._formBuilder.group(group);
  }

  onToggleTab(event: any) {
    const tabs = Object.keys(this.stepConfig);
    const steps = ['info','role','scope']
    if(this.userId) {
      this.currentTab = steps[event?.selectedIndex];
      tabs.forEach((tabs: any) => {
        if(tabs === steps[event?.selectedIndex]) {
          this.stepConfig[tabs as keyof typeof this.stepConfig] = 1;
          this.router.navigate(['um','users','config'], {
            queryParams: {
              config: steps[event?.selectedIndex]
            },
            queryParamsHandling: 'merge'
          })
        }else {
          this.stepConfig[tabs as keyof typeof this.stepConfig] = 0;
        }
      });
    }
    if(event?.selectedIndex!=0){
      this.stepper.steps.forEach(step => step.completed = false);
    }
  }

  initializeAddUserConfig(config: any) {
    return this.initSrv.loadConfig(config);
  }

  addUserConfigaration() {
    const config = {
      path: Path.ADD_USER_CONFIG_PATH,
      configType: Config.ADD_USER_CONFIG
    }
    this.initializeAddUserConfig(config).then((data: any) => {
      if (!this.isCustomer) {
        this.loading = true;
        this.httpSrv.makeGetApiCall('GET_CUSTOMERS_LIST', this.envService.baseUrl).subscribe((response: any) => {
          this.userConfig = data!.addUser;
          let formattedResponse = this.formatCustomerList(response);
          this.customerList = this.dataSrv.addOptionsToTableData(formattedResponse, UM_TABLE_CNST.RESOURCES_LIST.customers);
          this.loading = false;
        }, error => {
          this.utilSrv.showToastMessage("Failed to fetch customers list", "error");
          this.loading = false;
        })
      } else {
        this.userConfig = data!.addUser;
        this.customerList = [];
      }

      let options = {
        'queryParams': {
          size: USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT,
          offset: 0
        }
      }

      this.getAllUsersList(options);
    })
    .catch((err: any) => {
      console.log(err, 'waringin here');
    })
  }

  editUserConfigaration() {
    const config = {
      path: Path.EDIT_USER_CONFIG_PATH,
      configType: Config.EDIT_USER_CONFIG
    }
    this.initializeAddUserConfig(config).then(async (data: any) => {
      this.userConfig = data!.editUser;
          }).catch((err: any) => {
      console.log(err, 'waringin here');
    })
  }

  formatCustomerList(response: any) {
    let formattedCustomerList = [];

    for (let custId in response) {
      let customerInfo = response[custId];
      formattedCustomerList.push(customerInfo);
    }

    return formattedCustomerList;
  }

  // TODO: move this logic to directive.
  onlyAlphabet(event: any) {
    const pattern = /[a-zA-Z]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onlyLowerCaseAlphabet(event: any) {
    // const pattern = /[a-z]/;
    const pattern = /^[a-z0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]+$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onlyDigit(event: any) {
    const pattern = /[1-9]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  validateEmail(event: any) {
    let inputStr = event.target.value;
    this.isEmailValid = this.utilSrv.isEmailValid(this.emailPattern, inputStr);
  }

  onPaste(event: ClipboardEvent, key: any) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text');
    let trimmedText = pastedText?.replace(/[^a-zA-Z]/g, '');
    setTimeout(() => {
      trimmedText = trimmedText?.substr(0, 25);
      this.userForm.patchValue({
        [key]: trimmedText
      });
    }, 1);
  }


  checkLength(event: any) {
    let value = event.target.value;
    if(this.primaryMobileForm.getRawValue()?.primaryMobileNo !=null){
    const indexOfPlus = (this.primaryMobileForm.getRawValue()?.primaryMobileNo as any).indexOf('+');
    let dialCode = (this.primaryMobileForm.getRawValue()?.primaryMobileNo as any).slice(0, indexOfPlus + 3);
    let phoneNumberPart:any = (this.primaryMobileForm.getRawValue()?.primaryMobileNo as any).slice(indexOfPlus + 3);
    if(dialCode == '+91' && !(phoneNumberPart.toString().length === 10)){
      this.isPrimaryMobileNoValid = false;
      this.primaryMobileForm.get('primaryMobileNo')?.setValue(undefined);
      this.primaryMobileForm.get('primaryMobileNo')?.updateValueAndValidity();
      return;
    }
    }
    if (value.length > 0) {
      this.isPrimaryMobileNoValid = this.primaryMobileForm.invalid ? false : true;
    } else {
      this.isPrimaryMobileNoValid = true;
    }
  }

  // Add user to db.
  handleAdd() {

    if (this.userForm.invalid) {
      // TODO: handle errors.
      return;
    }

    //* If it is super admin need to check selected customer
    // if(!this.isCustomer && (!this.userForm.value.customers || !this.userForm.value.customers.customerId || !this.userForm.value.customers.customerName)){
    //   this.utilSrv.showToastMessage("Please select customer","error");
    //   return;
    // }

    //* Create post data for add user
    const postdata = this.postDataCreationForAddUser();

    this.loading = true;
    //* Api call for add user
    this.httpSrv.makePostApiCall('ADD_USER', postdata, this.envService.baseUrl).subscribe({
      next: (res: any) => {
        if (res.result) {
          this.utilSrv.showToastMessage("Successfully added new user","success");
          const userId = res.response;
          let { USER_MODULE_OPERATIONS } = USER_MGMT_CNST;
          this.stepConfig.info = 0;
          this.stepConfig.role = 1;
          this.stepper.next();
          this.router.navigate(['um','users', 'config'], {
            queryParams: {
              operation: USER_MODULE_OPERATIONS.UPDATE_USER,
              config: 'role',
              userId,
              applicationName: '-',
              roleName: '-',
              title:'add'
            }
          })
        } else {
          this.utilSrv.showToastMessage("Error occured while creating user","error");
        }
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        let { error } = err;
        if (this.utilSrv.isObjectNotNullAndEmpty(error)) {
          let { message } = error;
          if (message) {
            if(message.includes('users_mobile_number_key')) {
              this.utilSrv.showToastMessage("Mobile Number Already Exists", "error");
            }else {
              this.utilSrv.showToastMessage(message, "error");
            }
          } else {
            this.utilSrv.showToastMessage("Error occured while creating user","error");
          }
        } else {
          this.utilSrv.showToastMessage("Error occured while creating user","error");
        }
      }
    });
  }

  //* post data creation for add user
  postDataCreationForAddUser(){
    const postdata : any = {
      metaInfo: {
        "username": this.userForm.value.username,
        "firstName": this.userForm.value.firstName,
        "lastName": this.userForm.value.lastName,
        "email": this.userForm.value.email,
        "mobileNo": this.primaryMobileForm.controls['primaryMobileNo'].value,
        "customerId": "",
        "customerName": "",
        "reportingToId": this.userForm.value.reportingToId == '' ? null : this.userForm.value.reportingToId,

      }
    }
    if(this.hasExtraFields){
      postdata['metaInfo']['userDetailsJson'] = {};
      postdata['metaInfo']['userDetailsJson']['data']=this.userForm.value.extraFields;
    }
    //* super admin get from selected customer / for customers fetch from login details
    if (!this.isCustomer && this.userForm.value.customers && this.userForm.value.customers.customerId && this.userForm.value.customers.customerName) {
      postdata['metaInfo']['customerId'] = this.userForm.value.customers.customerId;
      postdata['metaInfo']['customerName'] = this.userForm.value.customers.customerName;
    } else {
      this.userMetaInfo = this.appState.getUserMetaInfo();
      postdata['metaInfo']['customerId'] = this.userMetaInfo['customerId'];
      postdata['metaInfo']['customerName'] = this.userMetaInfo['customerName'];
    }

    return postdata;
  }

  // Edit User :: User Info 

  getUserInfoByUserId(userId : string) : Promise<any> {
    let promise = new Promise((resolve) => {
      if (userId) {
        let options = {
          'uriParams': {
            userId
          }
        }
        this.loading = true;
        this.httpSrv.makeGetApiCall('FETCH_USER_INFO_BY_ID', this.envService.baseUrl, options).subscribe((response: any) => {
          resolve(response.response.meta);
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error in fetching user info by user id ", error);
          this.utilSrv.showToastMessage("Error in fetching user info", "error");
          resolve({});
        })
      }
    })
    return promise;
  }

  getAllUsersList(options:any) {
    let promise = new Promise((resolve) => {
      this.loading = true;
      this.httpSrv.makeGetApiCall('GET_USER_LIST', this.envService.baseUrl, options).subscribe({
        next: (userList: any[]) => {
          userList = Array.isArray(userList) ? userList : userList['response'];
          this.allUserList = this.dataSrv.addOptionsToTableData(userList, UM_TABLE_CNST.RESOURCES_LIST.user);

          //inlint filter to only pick first name, last name, userId
          this.allUserList = this.allUserList.map((user: any) => {
            return {
              firstName: user.firstName,
              lastName: user.lastName,
              userId: user.userId,
              username: user.username,
              customerName: user.customerName,
              customerId: user.customerId
            }
          });

          //sort the list based on first name + last name
          this.allUserList = this.allUserList.sort((a: any, b: any) => {
            let nameA = a.firstName + a.lastName;
            let nameB = b.firstName + b.lastName;
            return nameA.localeCompare(nameB);
          });

          //filter out same username
          this.filteredUsersList = this.allUserList
            .filter((user:any) => user.userId !== this.userId) // remove self
            .filter((user:any, index:any, self:any) =>
              index === self.findIndex((u:any) => u.userId === user.userId && u.userName === user.userName)
            );
          this.loading = false;
          resolve(this.allUserList);
        },
        complete: () => { },
        error: () => {
          this.loading = false;
          this.allUserList = [];
          resolve([]);
        }
      });
    })
    return promise;
  }
  
  // Edit User :: Load Roles For the User

  async loadData(){
    let options = {
      'queryParams': {
        size: USER_MGMT_CNST.INFINITE_SCROLL_OPTIONS.INFINITE_SCROLL_LIMIT,
        offset: 0
      }
    }
    this.userDetails = await this.getUserInfoByUserId(this.userId);
    this.allUserList = await this.getAllUsersList(options);
    this.loadRoles();
  }

  loadRoles() {
    this.filteredRoles = [];
    let userId =  this.userId;
    let options = {
      uriParams:{
        userId : userId
      }
    }
    // Load Roles
    this.loading = true;
    this.httpSrv.makeGetApiCall('LIST_OF_PROFILES_FOR_USER', this.envService.baseUrl,options).subscribe({
      next: (roles: any) => {
        this.roles = roles['response'] || [];
        this.loadScopeEndPoints();
        this.filteredRoles = this.roles.map(r => {
          if(r.roleDetailsJson && r.roleDetailsJson.validScopes) {
            r.roleDetailsJson.validScopes = r.roleDetailsJson.validScopes.map((s: any) => (
              {...s, valuesLoaded: false, scopeValue: this.applications}
            ))
          }
          return r;
        });
        // this.loading = false;
      },
      error: () => {
        this.roles = [];
        this.loading = false;
      }
    });
  }

  loadScopeEndPoints() {
    this.appIdMap = {};
    this.loading =true;
    this.httpSrv.makeGetApiCall("GET_APPLICATIONS_LIST", this.envService.baseUrl).subscribe({
      next: (apps: any) => {
        this.userApplications = apps;
        apps.forEach((app: any) => {
          this.appIdMap[app.applicationId] = app;
        })
        this.prepopulateUserData(this.userDetails);
        this.fetchAdditionalFields(false,this.customerId);
        // this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        console.log("Err:: ", err);
      }
    });
  }

  /**================== Scope Changes ======================== */
  get scopeArray(): FormArray {
    return this.roleForm.get("scope") as FormArray;
  }

  getFiltersOfRole(index: number): any[] {
    const roleId = this.getRoleIdFromScopeArray(index);

    if(!roleId) return [];
    return this.getValidScopeOfRole(roleId);
  }

  setAddFilter(index: number): boolean {
    const scopeList = this.getFiltersOfRole(index);

    return scopeList.length > 0? false: true;
  }

  newRoleFormGroup(roleId: string, filters: any[]): FormGroup {
    // Build formControl obj.
    let formControls: {
      roleId: FormControl<any>
    } = {
      roleId: new FormControl(roleId, []),
    }

    // Build formControls for filters(scope) and push it to formControl Obj..
    filters.forEach(f => {
      if(f.scopeName) {
        // Filters are not required
        // TODO: Replace scope name with scopeId()
        formControls[f.scopeName as keyof typeof formControls] = new FormControl([], []);
      }
    })

    // Build formgroup with roleId and filters and return it.
    return new FormGroup(formControls);
  }

  addRole(roleId: string = '') {
    // fetch the new role
    const newRoleId = roleId || this.roleForm.get('newRole')?.value;

    if(!newRoleId) return;

    // Get role info
    const roleInfo = this.getRoleInfoById(newRoleId);

    if(roleInfo && roleInfo.applicationId) {
      this.roleRemoved = false;
      this.selectedApplications[roleInfo.applicationId] = true;
    }

    // Get the filters for role.
    const filters = this.getValidScopeOfRole(newRoleId);

    if(filters.length > 0) {
      this.scopeValueList.push({});
    }

    // Find the list of filters for which we need to load the values.
    const loadValuesForFilters = filters.filter(f => {
      const filterId = this.getScopeId(f);
      if(filterId) {
        return !this.filterOptions[filterId];
      }
      return false;
    });

    this.loadFilterOptions(newRoleId, loadValuesForFilters);

    this.scopeArray.push(this.newRoleFormGroup(newRoleId, filters));

    // Filter the roles dropdown.
    this.filterRoles();

    // reset the new role value.
    this.roleForm.get('newRole')?.reset();
  }

  addNewScopeValue(rolescope: any) {
    this.scopeValueList.push({});
    const roleId = rolescope.value['roleId']
    const filters = this.getValidScopeOfRole(roleId);
    this.scopeArray.push(this.newRoleFormGroup(roleId, filters))
  }

  scopeValueSelected(scopeValuesList: any[], index: number, filter: any) {
    if(filter.scopeType == 'HIERARCHY') {
      const roleId = this.getRoleIdFromScopeArray(index);
      const roleInfo = this.getRoleInfoById(roleId);
      const hirerachy = roleInfo.roleDetailsJson.validScopes.find((scope: any) => scope['scopeType'] == 'HIERARCHY');
      const scopeValuesSelected = this.roleForm.get('scope')?.value[0][filter.scopeName];
      if(hirerachy) {
        if(hirerachy['scopeName'] == filter.scopeName) {
          // this.scopeArray.push(this.addRoleFormGroup(roleId, scopeValuesSelected));
          for(let scopeValue of scopeValuesSelected) {
            const dependentValues = scopeValuesList.find((loc: any) => loc['label'] == scopeValue)['child'];
            this.scopeChildAvailable = true;
            this.filterOptions[filter.scopeName + '_' +scopeValue] = dependentValues;
          }
        }else {
          return
        }
      }else {
        return
      }
    }
  }

  removeScope(index: number) {
    const roleId = this.getRoleIdFromScopeArray(index);
    const roleInfo = this.getRoleInfoById(roleId);

    if (roleInfo) {
      this.roleRemoved = false;
      if (this.selectedApplications[roleInfo.applicationId]) {
        delete this.selectedApplications[roleInfo.applicationId];
      }
    } else {
      this.roleRemoved = true;
    }

    this.scopeArray.removeAt(index);
    this.filterRoles();
  }

  updateScopeValidity(event:any){
    this.isScopeValidObject[event?.applicationName] = event.valid;
    this.isScopeValid = Object.values(this.isScopeValidObject).every((value) => value === true);
  }

  filterRoles() {
    // Filter the roles dropdown.
    this.filteredRoles = this.roles.filter(r => !this.selectedApplications[r.applicationId]);
  }

  getApplicationScopeEndPoint(appId: string) {
    if(!appId) return null;
    return this.appIdMap[appId] ? this.appIdMap[appId].scopeEndPoint : null;
  }

  getApplicationIdOfRole(roleId: string) {
    if(!roleId) return null;

    const roleInfo = this.roles.find(r => r.roleId === roleId);
    return roleInfo ? roleInfo.applicationId : null;
  }

  getScopeId(scope: any) {
    if(!scope) return null as any;

    return `${scope.scopeType}__${scope.scopeName}`;
  }

  getRoleIdFromScopeArray(index: number) {
    if(index == null || index == undefined) return null;

    if(!this.scopeArray.controls || !this.scopeArray.controls[index]) return null;

    return this.scopeArray.controls[index].get('roleId')?.value;
  }

  getRoleName(index: number, roleName : string=''): string {
    const roleId = this.getRoleIdFromScopeArray(index);

    if(!roleId) return '';
    let roleInfo = this.getRoleDetailsById(roleId);
    if(!roleInfo) {
      roleInfo = this.getRoleInfoById(roleId);
    }
    return roleInfo ? roleInfo.applicationName : this.currentApplicationName
  }

  getRoleNameAndApplicationName(index: number, roleName : string=''): string {
    const roleId = this.getRoleIdFromScopeArray(index);

    if(!roleId) return '';
    let roleInfo = this.getRoleDetailsById(roleId);
    if(!roleInfo) {
      roleInfo = this.getRoleInfoById(roleId);
    }
    return roleInfo ? roleInfo.roleName+' ('+roleInfo.applicationName+")" : this.currentRoleName +' ('+this.currentApplicationName+")"
  }

  hasRolesAssigned(): boolean {
    return this.scopeArray.controls.length > 0;
  }

  getRoleDetailsById(roleId: string) {
    return this.roleDetails.find(r => r.roleId === roleId);
  }

  getRoleInfoById(roleId: string) {
    return this.roles.find(r => r.roleId === roleId);
  }

  getValidScopeOfRole(roleId: string): any[] {
    const roleInfo = this.getRoleInfoById(roleId);
    if(!roleInfo) return [];

    if(!roleInfo.roleDetailsJson || !roleInfo.roleDetailsJson.validScopes) return [];

    return roleInfo.roleDetailsJson.validScopes;
  }

  // TODO: replace with api call.
  fetchScopeValuesForFilter(roleId: string, scope: any): Observable<any> {
    const scopeName = scope.scopeName
    if(!roleId || !scope || (scope.scopeType == 'HIERARCHY' && scope.scopeName.includes('Location') && !scope.scopeName.includes('_') && !scope.scopeName.split('_')[1])) return of([]);

    // fetch application id of role.
    const applicationIdOfRole = this.getApplicationIdOfRole(roleId);
    if(!applicationIdOfRole) return of([]);

    // Fetch scope end point of application.
    const applicationScopeEndPoint = this.getApplicationScopeEndPoint(applicationIdOfRole);
    if(!applicationScopeEndPoint) return of([]);

    return this.httpSrv.makeGetApiCall('GET_SCOPE_VALUES_OF_TYPE', applicationScopeEndPoint, {
      replaceParams: {
        REPLACE_SCOPE_TYPE: scope.scopeType,
        REPLACE_SCOPE_NAME: scope.scopeName
      },
      headers: {
        CustomerId: this.customerId
      }
    });
  }

  loadFilterOptions(roleId: any, filters: any) {
    let isDataPass =  true;
    let promises = filters.map((f: any) => {
      if(f.scopeType == 'NON_HIERARCHY') {
        return this.fetchScopeValuesForFilter(roleId, f);
      }else {
        if(isDataPass) {
          return this.fetchScopeValuesForFilter(roleId, f);
        }
        isDataPass = false;
        return
      }
    });

    forkJoin(promises).subscribe({
      next: (res: any) => {
        filters.forEach((f: any, i: any) => {
          const data = res[i];
          const filterOptions: any[] = data ? data  : [];
          this.filterOptions[this.getScopeId(f) as keyof typeof filterOptions] = filterOptions;
        });
      },
      error: (err: any) => {
        console.log("Err:: ", err);
      }
    });
  }

  scopeSelectedHierachy(_event: any, scope: any) {
    const formData = this.roleForm.get('scope')?.value[_event];
    const roleInfo = this.getRoleInfoById(formData.roleId);
    const index = roleInfo.roleDetailsJson.validScopes.findIndex((s: any) => s['scopeName'] == scope['scopeName']);
    const scopeData = {...roleInfo.roleDetailsJson.validScopes[index+1]};
    this.filterOptions[this.getScopeId(scopeData) as keyof (typeof this.filterOptions)] = [];
    scopeData['scopeName'] = scopeData['scopeName'] + '_' + this.roleForm.get('scope')?.value[_event][scope['scopeName']]
    this.fetchScopeValuesForFilter(formData.roleId, scopeData).subscribe((data: any) => {
      scopeData['scopeName'] = scopeData['scopeName'].split('_')[0];
      const filterOptions: any[] = data ? data  : [];
      this.filterOptions[this.getScopeId(scopeData) as keyof typeof filterOptions] = filterOptions;
    })
  }

  //TODO: Need to have autocomplete search for all values.
  handleAutoCompleteSuggestions(index: number, filter: any) {
    if(!index || !filter) return;

    filter.scopeValue = ['Search'];
  }

  onEntriesChange(updatedEntries: any,control:AbstractControl | null,FormGroup:any,controlName:string) {
    // this.entries = updatedEntries;

    let entries:string[] = [];
    updatedEntries.forEach((entry:any) => {
      entries.push(JSON.stringify(entry));
    })
    if (control) {
      control.setValue(entries);
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }

  convertResourcesToArrays(applicationsData: any): any {
    const applications: any = JSON.parse(JSON.stringify(applicationsData));
    for (const appName in applications) {
      const app = applications[appName];
      if (app.resources && typeof app.resources === 'object' && !Array.isArray(app.resources)) {
        const resourcesMap = app.resources as any;
        const resourcesArray: any[] = [];
        
        for (const resourceName in resourcesMap) {
          resourcesArray.push(resourcesMap[resourceName]);
        }
        app.resources = resourcesArray;
      }
    }
    
    return applications;
  }

  
  /**============== End of scope changes ======================== */

  prepopulateUserData(data: any) {
    if(!data) return;

    const roles = (data.applications || []).filter((a: any) => !!a.roleId).map((a: any) => a.roleId);
    this.userForm.disable();
    this.roleForm.disable();
    this.scopeArray.clear();
    
    let primaryContactControl: any =   this.primaryMobileForm.patchValue({
        primaryMobileNo: data.mobileNo || '' 
       });
    this.userForm.setValue({
      firstName: data.firstName || '',
      lastName: data.lastName || '',
      email: data.email || '',
      status: data.status == null || data.status == undefined? 'Active' : data.status? 'Active': 'Inactive',
      customer : this.customerName,
      username : data.username,
      reportingToId: data.reportingToId || ''
    });
    this.roleForm.setValue({
      newRole: null,
      scope: [] // TODO: Prepopulate scope
    })
    this.loading = true;
    this.httpSrv.makeGetApiCall('GET_USER_PERMISSIONS', this.envService.baseUrl, {uriParams:  {userId: data.userId}}).subscribe({
      next: (res: any) => {
        const metaInfo = res.response.meta;
        const permissions = res.response && res.response.permissions ? res.response.permissions : {};
        this.userDbSnapshot = res.response;
        if(permissions){
          this.userPermissionresourseList =this.convertResourcesToArrays(permissions);
        }
        if (Object.keys(metaInfo).length > 0) {
          let { customerName, username, mobileNo, customerId } = metaInfo;

          this.customerName = customerName;
          this.userName = username;
          this.mobileNumber = mobileNo;
          this.customerId = customerId;
        }

        let roles: any[] = [];
        for(let key in permissions) {
          let { applicationId, applicationName, roleId, roleName, userRoleScope } = permissions[key];
          roles.push({ applicationId, applicationName, roleId, roleName, userRoleScope });
        }
        this.roleDetails = roles;
        roles.forEach((r, i) => {
          this.selectedApplications[r.applicationId] = true;
          this.addRole(r.roleId);
          const scopeGroupValue: {
            roleId: any
          } = {
            roleId: r.roleId
          }
          if(r.userRoleScope && r.userRoleScope.scope) {
            r.userRoleScope.scope.forEach((s: any) => {
              if(s.scopeType == 'HIERARCHY') {
                let ind = 0;
                for(let value of s.scopeValue) {
                  value = JSON.parse(value);
                  if(ind > 0) {
                    const roleValue = {
                      value: {
                        roleId: value['roleId']
                      }
                    }
                    this.addNewScopeValue(roleValue);
                  }
                  scopeGroupValue[value.roleId as keyof typeof scopeGroupValue] = value;
                  this.prepopulateFilterofRoleForHierarchy(ind, scopeGroupValue);
                  ind++;
                }
              }else {
                scopeGroupValue[s.scopeName as keyof typeof scopeGroupValue] = s.scopeType == 'NON_HIERARCHY'?s.scopeValue:s.scopeValue[0];
                this.prepopulateFiltersOfRole(i, scopeGroupValue);
              }
            })
          }
        })
        if(this.operation != USER_MGMT_CNST.USER_MODULE_OPERATIONS.VIEW_USER) {
          this.userForm.enable();
          this.roleForm.enable();
          if(this.operation == USER_MGMT_CNST.USER_MODULE_OPERATIONS.UPDATE_USER) {
            this.userForm.get('email')?.disable();
          }
        }else {
          this.scopeArray.disable();
        }
        this.loading = false;
      },
      error: (err: any) => {
        console.log("error loading user info: ", err);
        if(this.operation != USER_MGMT_CNST.USER_MODULE_OPERATIONS.VIEW_USER) {
          this.userForm.enable();
          this.roleForm.enable();
        }else {
          this.scopeArray.disable();
        }
        this.loading = false;
      }
    });
    // TODO: update filteredRoles depends on the user scope.
  }

  prepopulateFiltersOfRole(index: number, values: any) {
    if(index == null || index == undefined || !values || !values.roleId) return;

    if(this.scopeArray.controls.length <= index) return;

    for(let key in values) {
      if(this.scopeArray.controls[index].get(key)) {
        this.scopeArray.controls[index].get(key)?.setValue(values[key]);
      }
    }
  }

  prepopulateFilterofRoleForHierarchy(index: number, values: any) {
    if(!values || !values.roleId) return;
    for(let scope in values) {
      let i = 0;
      for(let key in values[scope]) {        
        if(this.scopeArray.controls[(index)].get(key)) {
          if(i > 0) {
            const roleData = this.roles.find((role: any) => role['roleId'] == scope);
            this.scopeSelectedHierachy(index, roleData.roleDetailsJson.validScopes[0]);
          }
          this.scopeArray.controls[index].get(key)?.setValue(values[scope][key]);
        }
        i++;
      }
    }
  }

  //Update Role
  handleUpdate() {
    if(this.userForm.invalid) {
      console.log("invalid edit form: ", this.userForm.errors);
      return;
    }
    const updatedUserInfo = this.hasExtraFields ? this.getUpdateUserInfoObj() : this.userForm.getRawValue();
    
    const userInfo = {...this.userDetails, email: this.userDetails.email};

    const scope = typeof this.roleForm.value.scope == 'string'? JSON.parse(this.roleForm.value.scope):this.roleForm.value.scope || [];
    const userRoleMapping: any = {};
    let breakLook = false;
    for(let s of scope) {
      // fetch existing role info
      // if not present create a new entry.
      userRoleMapping[s.roleId] = userRoleMapping[s.roleId] || {};
      
      // Get filter of role
      const filtersOfRole = this.getValidScopeOfRole(typeof s == 'string'?JSON.parse(s).roleId: s.roleId);
      
      // Build scope of the role.
      let scopeData: any = [];
      filtersOfRole.forEach(filter => {
        if(filter.scopeType == 'HIERARCHY') {
          const scopeObj = {
            scopeType: filter.scopeType,
            scopeValue: scope
          }
          scopeData = scopeObj;
          breakLook = true;
        }else {
          const scopeObj = {
            scopeType: filter.scopeType,
            scopeName: filter.scopeName,
            scopeValue: filter.scopeType == 'HIERARCHY'?s[filter.scopeName]:s[filter.scopeName] 
          }
          scopeData.push(scopeObj);
        }
      });
            
        for(let sc in scopeData.scopeValue) {
          scopeData.scopeValue[sc] = JSON.stringify(scopeData.scopeValue[sc]);
        }
      
      // Fetch existing scope if any.
      userRoleMapping[typeof s == 'string'?JSON.parse(s).roleId: s.roleId].scope = userRoleMapping[typeof s == 'string'?JSON.parse(s).roleId: s.roleId].scope || [];

      // add the current scope to the role.
      userRoleMapping[typeof s == 'string'?JSON.parse(s).roleId: s.roleId].scope = userRoleMapping[typeof s == 'string'?JSON.parse(s).roleId: s.roleId].scope.concat(scopeData);
      if(breakLook) {
        break;
      }
    }

    let roleIdToNameMapping: any = {};
    this.roles.forEach(r => roleIdToNameMapping[r.roleId] = r.roleName);

    let roleIdtoApplicationIdMapping: any = {};
    this.roles.forEach(r => roleIdtoApplicationIdMapping[r.roleId] = r.applicationId);

    // Compare the updatedRoleMapping with dbSnapshot
    // And move the roles to appropriate buckets(addRoles,UpdateRole,deleteRole)
    const existingPermissions = this.userDbSnapshot.permissions || {};
    const existingRolesOfUser: any = {};
    Object.values(existingPermissions).forEach((p:any) => existingRolesOfUser[p.roleId] = p);

    let addRoles: any = {};
    let updateRoles: any = {};
    let deleteRoles: any[] = [];
    let applicationsToUpdate: string[] = [];

    // Find New roles
    // If role not found in existingPermissions then it's a new one.
    for(let role in userRoleMapping) {
      if(existingRolesOfUser[role]) {
        // TODO: check for scope if scope chagned then only push it to updateRoles.
      if(userRoleMapping[role].scope?.length > 0){
        userRoleMapping[role].scope.forEach((scope:any) => {
          if(scope.scopeType === 'HIERARCHY'){
            scope.scopeValue = scope.scopeValue?.filter((sv:any) => sv.includes(role));
          }
        })
      }
        updateRoles[role] = userRoleMapping[role];
      }

      if(!existingRolesOfUser[role]) {
        addRoles[role] = userRoleMapping[role];
        if(roleIdtoApplicationIdMapping[role]) {
          applicationsToUpdate.push(roleIdtoApplicationIdMapping[role]);
        }
      }
    };

    // Find deleted Roles
    for(let role in existingRolesOfUser) {
      const roleName = roleIdToNameMapping[role];
      if(!userRoleMapping[role]) {
        deleteRoles.push(role);
        if(roleIdtoApplicationIdMapping[role]) {
          applicationsToUpdate.push(roleIdtoApplicationIdMapping[role]);
        }
      }
    }

    //TODO : Send meta information (username, mobileNo etc) only if these fields are changed
    let metaInfo = null;

    let isMetaInfoChanged = this.getMetaInfoStr(updatedUserInfo) !== this.getMetaInfoStr(userInfo) ? true : false;

    if (isMetaInfoChanged) {

      metaInfo = updatedUserInfo;
      
      metaInfo = {
        ...metaInfo,
        username : this.userName,
        mobileNo : this.primaryMobileForm.value.primaryMobileNo,
        customerName : this.customerName,
        customerId : this.customerId
      }
    }

    const postData = {
      metaInfo,
      addRoles,
      updateRoles,
      deleteRoles,
      userId: this.userId,
    }

    this.updateUser(postData,applicationsToUpdate);
  }

  updateUser(postdata: any,applicationsToUpdate: string[]) {

    if (this.updateInProcess) return;

    this.updateInProcess = true;
    if (postdata['metaInfo']) {
      postdata['metaInfo']['status'] = postdata['metaInfo']['status'] === USER_MGMT_CNST.STATUS_TYPE_LIST.ACTIVE ? true : false;
    }
    const { userId = '', operation, ...rest } = postdata;
    let options:any = { uriParams: { userId } }
    if(Object.keys(postdata.addRoles).length > 0){
      options['queryParams'] = {sendEmail:false}
    }
    this.loading = true;
    this.httpSrv.makePutApiCall('UPDATE_USER', rest, this.envService.baseUrl, options).subscribe({
      next: (res: any) => {
        if(this.title == 'edit'){
          this.updateApplications(applicationsToUpdate);
        }
        this.updateInProcess = false;
        // this.router.navigate(['um', 'users']);
        this.utilSrv.showToastMessage('Successfully updated user details', 'success');
        this.loading = false;
        if(this.stepConfig['info'] == 1) {
          this.router.navigate(['um', 'users', 'config'], {
            queryParams: {
              config: 'role'
            },
            queryParamsHandling: 'merge'
          })
        } else if(this.stepConfig['role'] == 1) {
          this.router.navigate(['um', 'users', 'config'], {
            queryParams: {
              config: 'scope'
            },
            queryParamsHandling: 'merge'
          })
        }
        else {
          this.router.navigate(['um', 'users']);
        }
     
      },
      complete:() => {} ,
      error: (err: any) => {
        this.updateInProcess = false;
        this.utilSrv.showToastMessage("Error occured while updating the user", 'error');
        this.loading = false;
      }
    });
  }

  async updateApplications(applicationsToUpdate:string[]) {
    if(!applicationsToUpdate || applicationsToUpdate.length == 0) return;
    let validUpdateApplications : string[] = [];

    applicationsToUpdate.forEach((appId: string) => {
      if(!this.productStandardAppsIds.includes(appId)) {
        validUpdateApplications.push(appId);
      }
    });
    if(validUpdateApplications.length == 0) return;
    const observables = validUpdateApplications.map(appId =>
      this.commonService.updateApplicationPublishStatus(appId).pipe(
        catchError((error: any) => {
          console.error(`Update failed for appId ${appId}:`, error);
          return of({ appId, success: false });
        })
      )
    );

    forkJoin(observables).subscribe(results => {});
  }

  getUpdateUserInfoObj(){
    let updateUserObj = this.userForm.getRawValue();
    if(this.userDetails?.userDetailsJson){
      this.userDetails.userDetailsJson['data'] = updateUserObj?.extraFields;
    }else{
      this.userDetails['userDetailsJson'] = {};
      this.userDetails.userDetailsJson['data'] = updateUserObj?.extraFields;
    }
    delete updateUserObj.extraFields;
    updateUserObj['userDetailsJson'] = this.userDetails.userDetailsJson;
    return updateUserObj;
  }

  checkScopeAvailable(): boolean {
    const scopes = this.scopeArray.getRawValue();
    return scopes.length > 0 && scopes.some((scope: any) => 'application' in scope || 'Application' in scope);
  }

  getMetaInfoStr(userInfo: any) {
    if(!userInfo) return '';

    return JSON.stringify({
      firstName: userInfo.firstName,
      lastName: userInfo.lastName,
      email: userInfo.email,
      status: userInfo.status
    })
  }

  navigateToUsers() {
    this.router.navigate(['um', 'users']);
  }

  navigateToEdit() {
    this.router.navigate(['um', 'users', 'config'], {
      queryParams: {
        operation: 'edit'
      },
      queryParamsHandling: 'merge'
    })
  }
  assertUserData(item: any): { roleName: string } {
    return item as { roleName: string };
  }
  moveToStep(index: number) {
    this.stepper.selectedIndex = index;
  }

  filterAndResetReportingToField(value:any){
    //deselct the reporting to user if customer is changed
    this.userForm.get('reportingToId')?.reset();
    
    //filter the users based on selected customer
    if(!isNullOrUndefined(value.value)){
      this.filteredUsersList = this.allUserList.filter((user: any) => user.customerId === value.value.customerId);
    }else{
      //if customer is not selected then show all users
      this.filteredUsersList = this.allUserList;
    }
    this.fetchAdditionalFields(true,value.value.customerId);
  }
}
